import styles from "./index.module.scss";
import { NextPage } from "next";
import StockInsiders from "@/components/stock-insiders/StockInsiders";
import { Stock } from "@/models/stock";
import Head from "next/head";
import { buildStockOgImage } from "@/lib/stock-og";
import { useSetAtom } from "jotai";
import { stockTradingItemIdState } from "@/lib/store";
import { useEffect } from "react";
import { stockPageGetServerSideProps } from "@/lib/stock-page-ssr";
import { stockTitle } from "@/lib/stock-seo";
import { stockCanonicalUrl } from "@/lib/stock-url";

const StockInsidersPage: NextPage<{ stock: Stock }> = ({ stock }) => {
    const setStockTradingItemId = useSetAtom(stockTradingItemIdState);

    useEffect(() => {
        stock ? setStockTradingItemId(stock.tradingitem_id) : setStockTradingItemId(null);
    }, [stock]);
    return (
        <>
            {stock &&
                (() => {
                    const { ogImageUrl, cardTitle } = buildStockOgImage(stock, "Insiders");
                    return (
                        <Head>
                            <title>{stockTitle(stock, "insiders")}</title>
                            <link rel="canonical" href={stockCanonicalUrl(stock, "insiders")} />
                            <meta name="keywords" content={`${stock.name}, ${stock.exchangesymbol}:${stock.ticker}, Insiders, Director Dealings`} />
                            <meta
                                name="description"
                                content={`Insider buying and selling at ${stock.name} (${stock.exchangesymbol}:${stock.ticker}) from official filings: recent transactions, current insider holdings and how the stock moved after each insider's past trades.`}
                            />
                            <meta name="twitter:card" content="summary_large_image" />
                            <meta name="twitter:title" content={stockTitle(stock, "insiders")} />
                            <meta
                                name="twitter:description"
                                content={`Insider buying and selling at ${stock.name} (${stock.exchangesymbol}:${stock.ticker}) from official filings: recent transactions, current insider holdings and how the stock moved after each insider's past trades.`}
                            />
                            <meta name="twitter:url" content={stockCanonicalUrl(stock, "insiders")} />
                            <meta name="twitter:image" content={ogImageUrl} />
                            <meta name="twitter:image:alt" content={cardTitle} />
                            <meta property="og:title" content={stockTitle(stock, "insiders")} />
                            <meta
                                property="og:description"
                                content={`Insider buying and selling at ${stock.name} (${stock.exchangesymbol}:${stock.ticker}) from official filings: recent transactions, current insider holdings and how the stock moved after each insider's past trades.`}
                            />
                            <meta property="og:url" content={stockCanonicalUrl(stock, "insiders")} />
                            <meta property="og:image" content={ogImageUrl} key="og:image" />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:image:alt" content={cardTitle} />
                        </Head>
                    );
                })()}
            <div className={styles.StockInsidersPage}>{stock ? <StockInsiders stock={stock} /> : <h1>Stock not found.</h1>}</div>
        </>
    );
};

export const getServerSideProps = stockPageGetServerSideProps({ tab: "insiders", allowedTypes: [1] });

export default StockInsidersPage;
